class Project {
  constructor({
    image = [],
    special_status = false,
    projectType = "paid",
    abs = 0,
    glow = 0,
    crystal = 0,
    dreamerDust = 0,
    startDate = "",
    endDate = "",
    orderStartDate = "",
    orderEndDate = "",
    kitReleaseDate = "",
    extraNotes = "",
    tags = [],
    timer_status = "paused",
    project_status = "ongoing",
    totalDuration = 0,
    _id = "",
    userId = "",
    artist = "",
    design = "",
    brand = "",
    canvas_width = 0,
    canvas_height = 0,
    canvas_start_image = "",
    canvas_complete_image = "",
    submit_project = false,
    diamond_type = "Round",
    no_of_color = 0,
    total_amount_diamonds = 0,
    price = 0.0,
    country_code = "US",
    currency_code = "usd",
    created_at = 0,
    __v = 0,
  }) {
    this.image = image;
    this.special_status = special_status;
    this.abs = abs;
    this.glow = glow;
    this.crystal = crystal;
    this.dreamerDust = dreamerDust;
    this.startDate = startDate;
    this.endDate = endDate;
    this.orderStartDate = orderStartDate;
    this.orderEndDate = orderEndDate;
    this.kitReleaseDate = kitReleaseDate;
    this.extraNotes = extraNotes;
    this.tags = tags;
    this.timer_status = timer_status;
    this.project_status = project_status;
    this.totalDuration = totalDuration;
    this._id = _id;
    this.userId = userId;
    this.artist = artist;
    this.design = design;
    this.brand = brand;
    this.projectType = projectType;
    this.canvas_width = canvas_width;
    this.canvas_height = canvas_height;
    this.canvas_start_image = canvas_start_image;
    this.canvas_complete_image = canvas_complete_image;
    this.diamond_type = diamond_type;
    this.no_of_color = no_of_color;
    this.total_amount_diamonds = total_amount_diamonds;
    this.price = price;
    this.submit_project = submit_project;
    this.currency_code = currency_code;
    this.country_code = country_code;
    this.created_at = created_at;
    this.__v = __v;
  }
}

class DataModel {
  constructor({
    projects = [],
    totalPages = 0,
    currentPage = 1,
    totalProjects = 0,
    hasNextPage = false,
  }) {
    this.projects = projects.map((project) => new Project(project));
    this.totalPages = totalPages;
    this.currentPage = currentPage;
    this.totalProjects = totalProjects;
    this.hasNextPage = hasNextPage;
  }
}

export { Project, DataModel };
